import gql from 'graphql-tag';

export const schema = `
  errors{
    code
    message
    additionalDetails{
      productName
      color
      size
    }
  }
  status
  lineItems {
    isStorePickup
    product {
      sku {
        skuId
      }
    }
  }
  loyalty {
    loyaltyFreeReturnsEligible
    loyaltyFreeShippingEligible
  }
  promotions{
    code
    walletCouponCode
  },
  rewards{
    rewardId
    expirationDate
  }
  sellerInfo {
    sellerId
    sellerName
    sellerImage
    cjEvent
  }
  customerStoreInfo {
    orderStore{
      storeId
      storeNumber
      name
      addressLine1
      city
      state
      postalCode
      country
      phoneNumber
      hoursOfOperation
      weeklyHoursOfOperation{
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      bopisEligible
      bopisMessage
      distance
      skus{
        sku
        quantity
        availabilityMessage
        bopisMessage
        atgInventoryQuantity
        backOrderable
      }
    }
    preferredStore{
      bopisEligible
    }
  }
`;

export default gql`
  query getOrderSummary($shouldRecalculateTax: Boolean) {
    orderSummary(shouldRecalculateTax: $shouldRecalculateTax) {
      ${schema}
    }
  }
`;
